var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBehaviorGraphLicking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 239.998,
    height: 34.0003,
    viewBox: "0 0 239.998 34.0003",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Behavior Card / Graph / Line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Graph",
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.998 33.0001C238.998 33.0001 215.16 27.0001 206.273 27.0001C197.386 27.0001 188.161 29.9406 179.499 27.005C170.836 24.0694 169.048 20.9889 161.649 23.0001C154.25 25.0113 147.166 25.0113 143.799 23.0001C140.431 20.9889 143.71 20.0001 131.899 20.0001C120.088 20.0001 121.138 14.3457 117.024 11.0001C112.91 7.65437 106.847 4.17706 96.1992 7.00005C85.5516 9.82305 78.2988 7.9616 75.3744 6.00005C72.4501 4.03851 70.0131 3.00005 63.4745 3.00005C56.9359 3.00005 56.9963 5.00005 51.5746 5.00005C46.153 5.00005 44.436 7.00005 36.6997 7.00005C28.9635 7.00005 24.5781 2.00257 18.8499 2.00257C13.1217 2.00257 1.00005 1.00005 1.00005 1.00005V33.0001H238.998Z",
    fill: "url(#paint0_linear_0_90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 348",
    opacity: 0.5,
    d: "M1.0025 13.0001L239 13",
    stroke: "#E2123C",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeDasharray: "0.1 3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Graph_2",
    d: "M238.998 33.0001C238.998 33.0001 215.16 27.0001 206.273 27.0001C197.386 27.0001 188.161 29.9406 179.499 27.005C170.836 24.0694 169.048 20.9889 161.649 23.0001C154.25 25.0113 147.166 25.0113 143.799 23.0001C140.431 20.9889 143.71 20.0001 131.899 20.0001C120.088 20.0001 121.138 14.3457 117.024 11.0001C112.91 7.65437 106.847 4.17706 96.1992 7.00005C85.5516 9.82305 78.2988 7.9616 75.3744 6.00005C72.4501 4.03851 70.0131 3.00005 63.4745 3.00005C56.9359 3.00005 56.9963 5.00005 51.5746 5.00005C46.153 5.00005 44.436 7.00005 36.6997 7.00005C28.9635 7.00005 24.5781 2.00257 18.8499 2.00257C13.1217 2.00257 1.00005 1.00005 1.00005 1.00005",
    stroke: "#E2123C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_90",
    x1: 238.492,
    y1: 1.00005,
    x2: 238.492,
    y2: 32.8639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE0D64",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE0D64",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehaviorGraphLicking);
export default __webpack_public_path__ + "static/media/behavior-graph-licking.48cd1b0dd80ae462a671efdc5e1fb2cf.svg";
export { ForwardRef as ReactComponent };